import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Play } from "lucide-react";

const VideoTestimonials = () => {
  const [selectedVideoId, setSelectedVideoId] = useState<string | null>(null);

  const testimonials = [
    {
      id: "iNvAPGAzbBE",
      title: "Seja um Licenciado GoPass",
      description: "Recado do Diretor da empresa sobre as oportunidades de licenciamento",
      thumbnail: `https://img.youtube.com/vi/iNvAPGAzbBE/maxresdefault.jpg`,
      author: "Diretor GoPass",
      category: "Seja um Licenciado"
    },
    {
      id: "A5Bs5PHO9JE", 
      title: "Histórias de Sucesso",
      description: "Depoimentos reais de parceiros que transformaram seus negócios",
      thumbnail: `https://img.youtube.com/vi/A5Bs5PHO9JE/maxresdefault.jpg`,
      author: "Parceiros GoPass",
      category: "Depoimentos"
    },
    {
      id: "uIzneBlgqNo",
      title: "Divulgação em TV Aberta SBT",
      description: "DESTAQUE: Mulheres passageiras, podem chamar mulheres motoristas",
      thumbnail: `https://img.youtube.com/vi/uIzneBlgqNo/maxresdefault.jpg`,
      author: "Marketing GoPass",
      category: "TV Aberta"
    },
    {
      id: "GuSEU5nWpso",
      title: "Parceria Influencer Local",
      description: "Experiências reais de expansão e desenvolvimento - ASSINATURA DE CORRIDAS",
      thumbnail: `https://img.youtube.com/vi/GuSEU5nWpso/maxresdefault.jpg`,
      author: "Parceiros GoPass",
      category: "Divulgação"
    },
    {
      id: "oVjBjvLvH3I",
      title: "Divulgação em TV Aberta",
      description: "Captação de Motoristas - Maior comissão do mercado",
      thumbnail: `https://img.youtube.com/vi/oVjBjvLvH3I/maxresdefault.jpg`,
      author: "MArketing GoPass",
      category: "Soluções"
    },
    {
      id: "_uX-zEwau2k",
      title: "Resultados Comprovados",
      description: "Cases reais de crescimento e sucesso de nossos parceiros",
      thumbnail: `https://img.youtube.com/vi/_uX-zEwau2k/maxresdefault.jpg`,
      author: "Parceiros GoPass", 
      category: "Resultados"
    },
    {
      id: "QXA8pZ2ZbEw",
      title: "GoPass em Ação",
      description: "Veja a plataforma funcionando na prática",
      thumbnail: `https://img.youtube.com/vi/QXA8pZ2ZbEw/maxresdefault.jpg`,
      author: "Equipe GoPass",
      category: "Demonstração"
    }
  ];

  return (
    <section id="cases" className="py-20 bg-gradient-subtle">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            Cases de <span className="text-primary">Sucesso</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Descubra como nossos parceiros estão transformando a mobilidade urbana 
            e alcançando resultados extraordinários com a GoPass.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {testimonials.map((video) => (
            <Dialog key={video.id} onOpenChange={(open) => !open && setSelectedVideoId(null)}>
              <DialogTrigger asChild>
                <Card 
                  className="group cursor-pointer overflow-hidden shadow-card-custom hover:shadow-elegant transition-all duration-300 transform hover:scale-105"
                  onClick={() => setSelectedVideoId(video.id)}
                >
                  <div className="relative">
                    <img 
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                      onError={(e) => {
                        e.currentTarget.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
                      }}
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors duration-300"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all duration-300 shadow-elegant">
                        <Play className="w-6 h-6 ml-1" />
                      </div>
                    </div>
                    <div className="absolute top-4 left-4">
                      <span className="bg-primary text-white px-3 py-1 rounded-full text-sm font-medium">
                        {video.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                      {video.title}
                    </h3>
                    <p className="text-muted-foreground mb-4 line-clamp-2">
                      {video.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-muted-foreground font-medium">
                        {video.author}
                      </span>
                      <Button 
                        variant="ghost" 
                        size="sm" 
                        className="text-primary hover:text-primary/80"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedVideoId(video.id);
                        }}
                      >
                        Assistir <Play className="w-4 h-4 ml-1" />
                      </Button>
                    </div>
                  </div>
                </Card>
              </DialogTrigger>

              {/* Modal com o player */}
              <DialogContent className="max-w-4xl w-full aspect-video p-0 bg-black">
                {selectedVideoId && (
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${selectedVideoId}?autoplay=1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    className="rounded-lg w-full h-full"
                  ></iframe>
                )}
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonials;
